var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgParentClause(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 24,
    viewBox: "0 0 54 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 23,
    rx: 11.5,
    fill: "#C5231E",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 53,
    height: 23,
    rx: 11.5,
    stroke: "#58A55D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.5007 18.3333C25.5784 18.3333 24.7118 18.1583 23.9007 17.8083C23.0895 17.4583 22.384 16.9833 21.784 16.3833C21.184 15.7833 20.709 15.0778 20.359 14.2667C20.009 13.4556 19.834 12.5889 19.834 11.6667C19.834 10.7444 20.009 9.87778 20.359 9.06667C20.709 8.25556 21.184 7.55 21.784 6.95C22.384 6.35 23.0895 5.875 23.9007 5.525C24.7118 5.175 25.5784 5 26.5007 5C27.4229 5 28.2895 5.175 29.1007 5.525C29.9118 5.875 30.6173 6.35 31.2173 6.95C31.8173 7.55 32.2923 8.25556 32.6423 9.06667C32.9923 9.87778 33.1673 10.7444 33.1673 11.6667C33.1673 12.5889 32.9923 13.4556 32.6423 14.2667C32.2923 15.0778 31.8173 15.7833 31.2173 16.3833C30.6173 16.9833 29.9118 17.4583 29.1007 17.8083C28.2895 18.1583 27.4229 18.3333 26.5007 18.3333ZM26.5007 17C27.1007 17 27.6784 16.9028 28.234 16.7083C28.7895 16.5139 29.3007 16.2333 29.7673 15.8667L22.3007 8.4C21.934 8.86667 21.6534 9.37778 21.459 9.93333C21.2645 10.4889 21.1673 11.0667 21.1673 11.6667C21.1673 13.1556 21.684 14.4167 22.7173 15.45C23.7507 16.4833 25.0118 17 26.5007 17ZM30.7007 14.9333C31.0673 14.4667 31.3479 13.9556 31.5423 13.4C31.7368 12.8444 31.834 12.2667 31.834 11.6667C31.834 10.1778 31.3173 8.91667 30.284 7.88333C29.2507 6.85 27.9895 6.33333 26.5007 6.33333C25.9007 6.33333 25.3229 6.43056 24.7673 6.625C24.2118 6.81944 23.7007 7.1 23.234 7.46667L30.7007 14.9333Z",
    fill: "#C5231E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParentClause);
export default __webpack_public_path__ + "static/media/parentClause.eec7e9bf9b690c968c60a8696cdb6879.svg";
export { ForwardRef as ReactComponent };